import { withTypography } from 'components/ui';

export const RecentOrdersDescriptionText = withTypography({ style: { marginBottom: 8 } });

export const HeadingStyled = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
  fontSize: '2xl',
  lineHeight: 32,
});
